import { render, staticRenderFns } from "./PackType.vue?vue&type=template&id=449ea819&"
import script from "./PackType.vue?vue&type=script&lang=js&"
export * from "./PackType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports